import React from 'react';
import { Ship } from 'lucide-react';
import LclBoardPage from './LclBoardPage';
import { SUBESTADOS_EN_CURSO } from '../utils/lclBoardConstants';

/**
 * Tablero "Operaciones en curso" — solicitudes LCL en estado `Enviada`.
 *
 * Sub-estados del ciclo marítimo:
 *  - "Booking"        : espacio reservado con la naviera/consolidador
 *  - "Consolidación"  : la carga se está consolidando en el contenedor
 *  - "En tránsito"    : el buque zarpó
 *  - "En aduana"      : arribó y está en trámite aduanero
 */
export default function LclInProgressBoardPage() {
  return (
    <LclBoardPage
      estado="Enviada"
      titulo="Operaciones LCL en curso"
      subtitulo="Solicitudes aprobadas por el cliente · seguimiento del embarque"
      icon={Ship}
      iconClass="bg-blue-100 text-blue-700"
      subEstadoOptions={SUBESTADOS_EN_CURSO}
      subEstadoDefault="Booking"
      exportFileName="lcl_en_curso"
      permiteInstrucciones
      permiteSeguimiento
    />
  );
}
